import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHeading, Reveal } from "./Reveal";
import { CTAButton } from "./CTAButton";
import { waLink } from "@/lib/site";

const FAQS = [
  { q: "Quanto custa criar um site?", a: "O valor depende das características, funcionalidades e nível de personalização do projeto. Entre em contato com a WebStation para receber um orçamento personalizado." },
  { q: "Vocês criam aplicativos?", a: "Sim. Criamos aplicativos personalizados de acordo com as necessidades de cada projeto." },
  { q: "Vocês atendem autônomos?", a: "Sim. A WebStation atende desde profissionais autônomos e pequenos negócios até empresas maiores." },
  { q: "Vocês atendem diferentes segmentos?", a: "Sim. Criamos soluções para diferentes tipos de negócios, como barbearias, restaurantes, lojas, e-commerces, escritórios, profissionais liberais e muito mais." },
  { q: "Preciso entender de tecnologia para contratar?", a: "Não. A WebStation orienta você durante o processo e transforma sua necessidade em uma solução digital profissional." },
  { q: "Quanto tempo demora para criar um projeto?", a: "O prazo depende da complexidade, quantidade de funcionalidades e características do projeto." },
];

export const FAQ = () => (
  <section id="faq" data-testid="faq-section" className="relative py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <SectionHeading index="10" eyebrow="FAQ" title="Perguntas frequentes" sub="Ficou alguma dúvida? Fale com um especialista da WebStation." testid="faq-title" />
        <Reveal delay={0.2}>
          <CTAButton testid="faq-cta" variant="ghost" className="mt-10" href={waLink()}>Falar com um especialista</CTAButton>
        </Reveal>
      </div>
      <Reveal delay={0.1} className="lg:col-span-7">
        <Accordion type="single" collapsible defaultValue="item-0" className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} data-testid={`faq-item-${i}`} className="rounded-2xl border border-white/[0.07] bg-ws-card px-5 transition-[border-color] duration-300 data-[state=open]:border-ws-lime/40 sm:px-6">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-5 text-left font-body text-base font-medium text-ws-text hover:no-underline [&>svg]:text-ws-lime">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-[15px] leading-relaxed text-ws-muted">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
